import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import ClearIcon from "@mui/icons-material/Clear";
import {
  Button,
  IconButton,
  Paper,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import DateRangeFilter from "../Common/DateRangeFilter";
import DownloadIcon from "@mui/icons-material/Download";
import SelectLayout from "../../pages/metrices/Components/SelectLayout";
import SelectGranularity from "../../pages/metrices/Components/SelectGranularity";
import ZoomInMapIcon from "@mui/icons-material/ZoomInMap";
import ZoomOutMapIcon from "@mui/icons-material/ZoomOutMap";
import { useAuthContext } from "../../context/AuthProvider";

function CustomHead({
  title = "",
  dateRange,
  setDateRange,
  value,
  setValue,
  finalDate,
  setFinalDate,
  downloadPermission = false,
  onDownload,
  page,
  setDownloadAllow,
  selectedLayout,
  setSelectedLayout,
  selectedGranularity,
  setSelectedGranularity,
  defaultStartDate = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000),
  defaultEndDate = new Date(Date.now() - 24 * 60 * 60 * 1000),
  handleOpenDownload = () => console.log("download"),
}) {
  const containerStyle1 = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    margin: "0px",
    padding: "5px 10px",
    borderRadius: "10px",
    fontWeight: 500,
    color: "#404040",
    boxShadow: "none",
    border: "1px solid #E4E4E4",
  };
  const containerStyle2 = {
    margin: "20px",
    width: "97%",
    padding: "10px",
    borderRadius: "10px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    fontWeight: 500,
    color: "#EFF3F5",
    boxShadow: "none",
    border: "1px solid #3EC2F0",
    background: "linear-gradient(to right, #202B69, #2E1C68, #202B69)",
    // backgroundColor: "#202B69",
  };
  const containerStyle3 = {
    padding: "10px",
    borderRadius: "10px",
    display: "flex",
    height: "55px",
    boxSizing: "border-box",
    justifyContent: "space-between",
    alignItems: "center",
    fontWeight: 500,
    color: "#404040",
    boxShadow: "none",
    border: "1px solid #E4E4E4",
  };
  const filterContainerStyle = {
    flex: 1,
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
  };
  const allTabStyle = {
    fontSize: "12px",
    border: page === "home" ? "none" : "1px solid #D4D4D4",
    borderRadius: "25px",
    marginRight: "10px",
  };
  const textStyle = {
    fontSize: "12px",
    marginRight: "10px",
    fontWeight: "500",
  };
  const chartPaperStyle = {
    flex: 1,
    borderRadius: "20px",
    height: "250px",
    // boxShadow: "0px 3px 6px #0000001F",
    boxShadow: "none",
    border: "1px solid #E4E4E4",
  };
  const layoutBoxStyle = {
    width: "97%",
    marginTop: "20px",
    mx: "auto",
    display: "flex",
    gap: "20px",
  };
  const headerBox = {
    height: "70px",
    boxShadow: "none",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "10px",
    borderRadius: "10px",
    fontWeight: 500,
    color: "#404040",
    // border: "1px solid #E4E4E4",
  };
  const { QCFull, setQCFull } = useAuthContext();
  const [toggleDateFilter, setToggleDateFilter] = useState(false);
  const handleChange = (event, newValue) => {
    setValue(newValue);
    if (newValue === 0) {
      setFinalDate({
        startDate: Date.now(),
        endDate: Date.now(),
      });
      setDateRange([
        {
          startDate: null,
          endDate: null,
          key: "selection",
          enabled: false,
          status: false,
        },
      ]);
    }
    if (newValue === 1) {
      setFinalDate({
        startDate: Date.now() - 7 * 24 * 60 * 60 * 1000,
        endDate: Date.now() - 1 * 24 * 60 * 60 * 1000,
      });
      setDateRange([
        {
          startDate: null,
          endDate: null,
          key: "selection",
          enabled: false,
          status: false,
        },
      ]);
    }
    if (newValue === 2) {
      setFinalDate({
        startDate: Date.now() - 30 * 24 * 60 * 60 * 1000,
        endDate: Date.now() - 1 * 24 * 60 * 60 * 1000,
      });
      setDateRange([
        {
          startDate: null,
          endDate: null,
          key: "selection",
          enabled: false,
          status: false,
        },
      ]);
    }
  };

  useEffect(() => {
    if (dateRange[0].enabled) {
      setValue(null);
    }
    if (value === 0) {
      setValue(0);
    }
    if (value === 1) {
      setValue(1);
    }
    if (value === 2) {
      setValue(2);
    }
  }, [dateRange[0].enabled]);

  const handleClickClearDateSelected = () => {
    setDateRange([
      {
        enabled: false,
        startDate: null,
        endDate: null,
        key: "selection",
        status: false,
      },
    ]);
    setValue(1);
    setFinalDate({
      startDate: null,
      endDate: null,
    });
  };

  // const handleClickClearDateSelected = () => {
  //   setDateRange([
  //     {
  //       enabled: false,
  //       startDate: null,
  //       endDate: null,
  //       key: "selection",
  //       status: false,
  //     },
  //   ]);
  //   setValue(1);
  //   setFinalDate({
  //     startDate: defaultStartDate,
  //     endDate: defaultEndDate,
  //   });
  // };

  return (
    <Paper
      style={
        page === "home"
          ? containerStyle2
          : page === "Metrices"
          ? headerBox
          : page === "Contribution"
          ? containerStyle3
          : containerStyle1
      }
    >
      {page != "Metrices" && (
        <Typography
          component="div"
          sx={{
            fontSize:
              page === "Metrices"
                ? "18px"
                : page === "Contribution"
                ? "20px"
                : "26px",
            color: page === "home" ? "white" : "#404040",
            fontWeight: "500",
            whiteSpace: "nowrap",
          }}
        >
          {title}
        </Typography>
      )}
      <div style={filterContainerStyle}>
        <>
          {dateRange?.[0]?.enabled && (
            <Typography sx={textStyle}>
              From {dateRange?.[0].startDate?.toLocaleDateString("en-US")}
              {" To "}
              {dateRange?.[0].endDate?.toLocaleDateString("en-US")}
            </Typography>
          )}
          {/* {(dateRange?.[0]?.enabled || value === 0) && ( */}
          {dateRange?.[0]?.enabled && (
            <IconButton
              onClick={
                // page === "Metrices" ? handleClickMetrices : handleClickDefault
                handleClickClearDateSelected
              }
              sx={{
                backgroundColor: "white",
                cursor: "pointer",
                height: "30px",
                width: "30px",
                border: "1px solid #e4e4e4",
                borderRadius: "20px",
                marginRight: "10px",
                fontSize: "12px",
                "&:hover": {
                  backgroundColor: "#e4e4e4",
                  color: "white",
                },
              }}
            >
              <ClearIcon
                size="small"
                sx={{
                  fontSize: "18px",
                }}
              />
            </IconButton>
          )}
          {/* {page != "Metrices" && ( */}
          <Tabs
            value={value}
            onChange={handleChange}
            centered
            sx={{
              "& .MuiTab-root": {
                minHeight: "35px",
                minWidth: "75px",
                height: "35px",
                color: page === "home" ? "white" : "black",
                fontWeight: 500,
                textTransform: "Capitalize",
              },
              "& .MuiTabs-indicator": {
                height: "0px",
              },
              "& .Mui-selected": {
                backgroundColor: "#0077B8",
                border: "1px solid #0077B6",
                borderRadius: "25px",
                color: "#FFFFFF !important",
              },
              display: "flex",
              alignItems: "center",
            }}
          >
            <Tab style={allTabStyle} label="Today" />
            <Tab style={allTabStyle} label="Past 7 Days" />
            {page != "Metrices" ||
              (page != "Summary" && (
                <Tab style={allTabStyle} label="Past 30 Days" />
              ))}
          </Tabs>
          {/* )} */}
        </>
        {page === "Metrices" && (
          <SelectLayout
            filterParts={selectedLayout}
            setFilterParts={setSelectedLayout}
          />
        )}
        <>
          <Button
            variant="contained"
            size="small"
            sx={{
              display: "flex",
              justifyContent: "space-between",
              columnGap: 1,
              textTransform: "initial",
              height: "32px",
              width: page === "Metrices" ? "180px" : "140px",
              fontSize: "12px",
              boxShadow: "none",
              backgroundColor: page === "home" ? "#263775" : "#fff",
              color: page === "home" ? "#EFF3F5" : "#404040",
              border:
                page === "home" ? "1px solid #3EC2F0" : "1px solid #D4D4D4",
              borderRadius: "25px",
              marginRight: "10px",
              "&:hover": {
                backgroundColor: page === "home" ? "#3EC2F0" : "#fff",
                boxShadow: "none",
              },
            }}
            onClick={() => {
              setToggleDateFilter(true);
              // setValue(null);
            }}
          >
            Date Range
            <CalendarMonthIcon sx={{ fontSize: "16px" }} />{" "}
          </Button>
          {page === "Metrices" && (
            <SelectGranularity
              filterParts={selectedGranularity}
              setFilterParts={setSelectedGranularity}
            />
          )}
          {downloadPermission && (
            <IconButton
              variant="contained"
              sx={{
                backgroundColor: page === "Home" ? "#3EC2F0" : "#0077B6",
                padding: "6px",
                color: "#fff",
                "&:hover": {
                  backgroundColor: page === "Home" ? "#3EC2F0" : "#0077B6",
                  color: "#EFF3F5",
                },
              }}
              onClick={() => {
                setDownloadAllow(true);
              }}
            >
              <DownloadIcon
                sx={{
                  fontSize: "22px",
                }}
              />
            </IconButton>
          )}
          {(page === "Metrices" || page === "Summary") && (
            <>
              <IconButton
                variant="contained"
                sx={{
                  backgroundColor: page === "Home" ? "#3EC2F0" : "#0077B6",
                  padding: "6px",
                  color: "#fff",
                  "&:hover": {
                    backgroundColor: page === "Home" ? "#3EC2F0" : "#0077B6",
                    color: "#EFF3F5",
                  },
                }}
                onClick={handleOpenDownload}
              >
                <DownloadIcon
                  sx={{
                    fontSize: "22px",
                  }}
                />
              </IconButton>
              {QCFull ? (
                <IconButton
                  variant="contained"
                  sx={{
                    backgroundColor: "#0077B6",
                    padding: "6px",
                    marginLeft: "10px",
                    color: "#fff",
                    "&:hover": {
                      backgroundColor: "#0077B6",
                      color: "white",
                    },
                  }}
                  onClick={() => setQCFull(!QCFull)}
                >
                  <ZoomInMapIcon />
                </IconButton>
              ) : (
                <>
                  <IconButton
                    variant="contained"
                    sx={{
                      backgroundColor: "#0077B6",
                      padding: "6px",
                      marginLeft: "10px",
                      color: "#fff",
                      "&:hover": {
                        backgroundColor: "#0077B6",
                        color: "white",
                      },
                    }}
                    onClick={() => setQCFull(!QCFull)}
                  >
                    <ZoomOutMapIcon />
                  </IconButton>
                </>
              )}
            </>
          )}
        </>
        {/* <>
            <PredictionParts
              filterParts={filterParts}
              setFilterParts={setFilterParts}
            />
            <IconButton
              variant="contained"
              sx={{
                backgroundColor: "#0077B6",
                padding: "6px",
                marginRight: "10px",
                color: "#fff",
                "&:hover": {
                  backgroundColor: "#0077B6",
                  color: "white",
                },
              }}
              onClick={onDownload}
            >
              <DownloadIcon
                sx={{
                  fontSize: "22px",
                }}
              />
            </IconButton>
          </> */}
      </div>
      {toggleDateFilter && (
        <DateRangeFilter
          open={toggleDateFilter}
          onClose={() => {
            setToggleDateFilter(false);
          }}
          onApply={() => {
            setToggleDateFilter(false);
            setDateRange([
              {
                ...dateRange?.[0],
                enabled: true,
                status: !dateRange?.[0]?.status,
              },
            ]);
            setFinalDate({
              startDate: dateRange?.[0].startDate,
              endDate: dateRange?.[0].endDate,
            });
            setValue(null);
          }}
          dateRange={dateRange}
          onChange={(data) => {
            setDateRange([
              {
                ...data?.[0],
                status: dateRange?.[0]?.status,
              },
            ]);
          }}
        />
      )}
    </Paper>
  );
}

export default CustomHead;
